import styled from 'styled-components';
import {getToken, getSpacing, getFontSize, getFontWeight, getPrimitive} from '@tickchak/react-share/app';
import {mobileMedia} from '../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexColumnCenter} from '../../globalVariables/GlobalFlex';

export const content = styled.div`
    width: 100%;
    max-width: 369px;
    max-height: min(90vh, 640px);
    ${dFlexColumnCenter}
    gap: ${getSpacing('spaceLg')};
    padding: ${getSpacing('spaceLg')};
    border-radius: var(--border-radius-border-radius-2xl, 24px);
    background: ${getToken('color.bg.base')};
    box-shadow: 0 12px 40px ${getPrimitive('blackAlphas.black30')};
    ${mobileMedia}{
        max-width: 100%;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;

    }
`;

export const title = styled.h2`
    text-align: center;
    font-size: var(--font-size-heading-page);
    font-weight: var(--font-weight-bold);
    line-height: 1.15;
`;

export const body = styled.p`
    text-align: center;
    font-size: ${getFontSize('body')};
    line-height: 1.4;
`;
        
export const footerRow = styled.div`
    ${dFlexCenter}
    gap: ${getSpacing('spaceSm')};
    width: 100%;
    > label {
        margin: 0;
    }
`;

export const checkboxLabel = styled.span`
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('regular')};
    line-height: 1.25;
    color: ${getToken('color.text.default')};
    text-align: center;
`;
